<template>
  <div>
    <div class="map-search">
      <GmapAutocomplete
        ref="gmapAutocomplete"
        @place_changed="setPlace"
        :value="addressInput"
        :options="{
          fields: ['geometry', 'formatted_address', 'address_components'],
        }"
      />
      <b-button
        size="sm"
        variant="primary"
        class="pac-target-buttom"
        @click="addMarker"
        >{{$t('search')}}</b-button
      >
    </div>
    <GmapMap
      :center="center"
      :zoom="12"
      style="width: 100%; height: 400px; margin-top: 20px"
      @click="mark"
    >
      <GmapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center = m.position"
      />
    </GmapMap>
  </div>
</template>
<script>
export default {
  props: ["location"],
  name: "web-map",
  data() {
    return {
      center: { lat: 21.0277644, lng: 105.8341598 },
      currentPlace: null,
      markers: [],
      addressInput: "",
      isButtom: true,
    };
  },
  mounted() {
    if (this.location.lat) {
      this.setMarkerMap({
        lat: parseFloat(this.location.lat),
        lng: parseFloat(this.location.lng),
      });
    }
  },
  methods: {
    setMarkerMap(loc) {
      this.markers = [{ position: loc }];
      this.center = loc;
    },
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.markers = [{ position: marker }];
        this.center = marker;
        this.currentPlace = null;
        this.$emit("marker", marker);
      }
    },
    mark(event) {
      const marker = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      this.$emit("marker", marker);
      this.$refs.gmapAutocomplete.$refs.input.value = "";
      this.markers = [{ position: marker }];
    },
  },
};
</script>

<style scoped>
.pac-container {
  z-index: 9999;
}
</style>
